exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  min-width: 300px; }\n\n.mat-table {\n  overflow-x: scroll; }\n\n.mat-cell,\n.mat-header-cell {\n  word-wrap: initial;\n  display: table-cell;\n  padding: 0px 10px 10px;\n  line-break: unset;\n  width: 100%;\n  white-space: nowrap;\n  vertical-align: middle; }\n\n.mat-row,\n.mat-header-row {\n  display: table-row; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/caixa/buscarExpurgo/buscarExpurgo.component.scss
// module id = ../../../../../src/app/components/caixa/buscarExpurgo/buscarExpurgo.component.scss
// module chunks = main